import axios from "axios"

const baseUrl = process.env.GATSBY_API_URL || ""

export const sendCustomerContact = (
  packageRequest: any,
  email: string,
  name: string,
  startTime: string,
  endTime: string,
  mobileNum: string
) => {
  return axios.post(`${baseUrl}/api/v1/sender`, {
    packageRequest,
    email,
    name,
    startTime,
    endTime,
    mobileNum,
  })
}
